module.exports = __webpack_public_path__ + "static/img/iso.ab137a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iso.png
// module id = 0vxc
// module chunks = 28